function SearchArea(props: any) {
  let myProps = {
    listOpt: {},
    list: (inData: any) => { },
    goDelete: (inData: any) => { },
    open_find_manager_popup: (inData: any) => { },
    ...props
  };
  let listOpt = myProps.listOpt;

  const on_change_search_input = (e: any) => {
    let name = e.target.name;
    let value = e.target.value;

    let change_list_opt: any = {
      ...myProps.listOpt,
    };
    change_list_opt[name] = value;

    myProps.list({
      ...change_list_opt,
      now_page: 1
    });
  };

  return (
    <div>
      <div className="my_flex_center">
        <input type="text" name="s_user_name_like" value={listOpt.s_user_name_like} onChange={on_change_search_input}
          className="search-input" placeholder="이름" style={{ width: "80px" }} />
        <button className='btn btn-dark'>검색</button>
        <button className="btn btn-dark"
          onClick={() => {
            myProps.open_find_manager_popup({});
          }}>찾기</button>
        <button className='btn btn-red'
          onClick={() => {
            myProps.goDelete({});
          }}>삭제</button>
      </div>
    </div>
  );
};
export default SearchArea;